import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL
} from "firebase/storage";

/**
 * อัปโหลดไฟล์รูปไป Firebase Storage
 * @param {File} file - ไฟล์จาก input[type=file]
 * @param {string} path - path เช่น `articles/covers/` หรือ `articles/images/`
 * @param {function} onProgress - callback(percent)
 * @returns {Promise<string>} downloadURL
 */
export function uploadImage(file, path = "uploads/", onProgress) {
  return new Promise((resolve, reject) => {
    try {
      const storage = getStorage();
      const filename = `${Date.now()}_${file.name.replace(/\s+/g, "_")}`;
      const storageRef = ref(storage, `${path}${filename}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress?.(Math.round(percent));
        },
        (error) => reject(error),
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        }
      );
    } catch (err) {
      reject(err);
    }
  });
}